
export const results = {
  title: 'Seus Resultados',
  subtitle: 'Análise comportamental abrangente',
  cognitiveAssessmentCTA: 'Complete Seu Perfil',
  cognitiveAssessmentDescription: 'Faça a Avaliação Cognitiva para obter seu perfil completo',
  downloadPDF: 'Baixar PDF',
  header: {
    assessmentComplete: 'Avaliação Completa',
    yourResults: 'Seus Resultados'
  },
  navigation: {
    backToHome: 'Voltar ao Início'
  },
  pdfDownload: {
    success: {
      title: 'PDF Baixado',
      description: 'Seu relatório de avaliação comportamental foi baixado com sucesso.'
    },
    error: {
      title: 'Falha na Exportação do PDF',
      description: 'Não foi possível gerar o PDF. Tente novamente.'
    }
  },
  cinematic: {
    home: 'Início',
    discoverYourStory: 'Descubra Sua História',
    youAre: 'Você É'
  },
  aiInsights: {
    aiPoweredAnalysis: 'Análise Baseada em IA',
    yourSuperpowers: 'Suas Fortalezas Principais',
    revealed: 'Reveladas',
    advancedAnalysis: 'Análise avançada de IA dos seus padrões de personalidade revela suas forças únicas e oportunidades de crescimento',
    keySuperpowers: 'Suas Fortalezas Principais',
    deepInsights: 'Insights Profundos',
    title: 'Suas Fortalezas de Estilo de Trabalho',
    badge: 'Análise Baseada em IA',
    subtitle: 'Celebrando suas forças únicas e áreas para crescimento consciente',
    regenerate: 'Nova Análise',
    regenerating: 'Regenerando...',
    backupBadge: 'Usando Análise de Backup',
    keyInsights: 'Insights Principais',
    detailedAnalysis: 'Análise Detalhada'
  },
  objectivity: {
    thinkingStyle: 'Estilo de Pensamento',
    decisionMakingStyle: 'Estilo de Tomada de Decisão',
    howYouMakeDecisions: 'Como Você Toma Decisões',
    uniqueApproach: 'Sua abordagem única para analisar informações e fazer escolhas',
    highlyAnalytical: 'Altamente Analítico',
    dataDriven: 'Orientado por Dados',
    balancedApproach: 'Abordagem Equilibrada',
    peopleFocused: 'Focado em Pessoas',
    highlyIntuitive: 'Altamente Intuitivo',
    intuitiveLeader: 'Líder Intuitivo',
    intuitive: 'Intuitivo',
    balanced: 'Equilibrado',
    analytical: 'Analítico',
    descriptions: {
      veryHigh: 'Você se destaca em tomar decisões puramente lógicas e baseadas em fatos com clareza analítica excepcional.',
      high: 'Você combina pensamento analítico forte com tomada de decisão prática, favorecendo dados enquanto mantém flexibilidade.',
      moderate: 'Você equilibra magistralmente análise lógica com inteligência emocional, considerando tanto fatos quanto pessoas.',
      low: 'Você prioriza relacionamentos e fatores humanos enquanto incorpora dados relevantes em suas decisões.',
      veryLow: 'Você lidera com intuição e inteligência emocional, criando soluções centradas nas pessoas que constroem relacionamentos fortes.'
    }
  },
  personalityStory: {
    yourPersonalityStory: 'Sua História de Personalidade',
    selfVsWork: 'Comportamento',
    analysis: 'Análise',
    theDataBehind: 'Os Dados Por Trás',
    yourUniqueness: 'Sua Singularidade',
    compareDescription: 'Compare como você se vê com suas expectativas de trabalho',
    basedOnWords: 'Aqui está o que te torna extraordinário',
    selfAssessment: 'Autoavaliação',
    workBehavior: 'Comportamento no Trabalho',
    naturalSelf: 'Eu Natural',
    workPersona: 'Persona Profissional',
    yourBehavioralProfile: 'Seu Perfil Comportamental',
    basedOnSelectedWords: 'Seus dados comportamentais'
  },
  behavioral: {
    basedOnWords: 'Sua análise comportamental',
    noDataAvailable: 'Nenhum dado disponível para esta seção.',
    warningNoResults: 'Aviso: Nenhum resultado comportamental encontrado para esta seção.',
    warningDetails: 'Isso pode acontecer se os dados não carregaram corretamente ou a avaliação estava incompleta.',
    noChartData: 'Nenhum dado de gráfico disponível.'
  },
  companyResults: {
    submittedTitle: 'Avaliação Enviada com Sucesso',
    submittedSubtitle: 'Seus resultados foram enviados com segurança para a empresa. Aqui está um resumo do seu desempenho.',
    selfBehavior: 'Comportamento Pessoal',
    workBehavior: 'Comportamento no Trabalho',
    profile: 'Perfil',
    drive: 'Impulso',
    connection: 'Conexão',
    task: 'Tarefa',
    order: 'Ordem',
    aiInsightsTitle: 'Insights de Personalidade por IA',
    refresh: 'Atualizar',
    keyStrengths: 'Fortalezas Principais',
    growthAreas: 'Áreas de Crescimento',
    recommendations: 'Recomendações',
    insightsError: 'Não foi possível gerar os insights de IA. Tente atualizar.',
    whatsNext: 'Próximos Passos',
    whatsNextDesc: 'Seus resultados foram salvos e compartilhados com o administrador da avaliação. Eles revisarão seu perfil e poderão entrar em contato com os próximos passos.',
    returnToHome: 'Voltar ao Início',
    workBehaviorProfile: 'Perfil de Comportamento no Trabalho',
    yourProfile: 'Seu Perfil',
    submittedSubtitleBehavioral: 'Seus resultados foram enviados com segurança para a empresa. Aqui está um resumo do seu perfil comportamental.',
    resultsSentSimple: 'Seus resultados foram enviados com segurança para a empresa.',
    thankYouMessage: 'Obrigado pelo seu tempo e esforço ao completar esta avaliação.',
    assessmentComplete: 'Avaliação Concluída',
    cognitiveResultsSubtitle: 'Aqui estão os resultados da sua avaliação cognitiva',
    overallCognitiveScore: 'Pontuação Cognitiva Geral',
    percentile: 'percentil',
    scoredHigherThan: 'Você pontuou mais alto que {{percentile}}% dos participantes',
    scoreBreakdown: 'Detalhamento da Pontuação',
    verbalReasoning: 'Raciocínio Verbal',
    verbalDescription: 'Compreensão linguística e lógica verbal',
    numericalReasoning: 'Raciocínio Numérico',
    numericalDescription: 'Análise matemática e quantitativa',
    abstractReasoning: 'Raciocínio Abstrato',
    abstractDescription: 'Reconhecimento de padrões e pensamento lógico',
    exceptional: 'Excepcional',
    aboveAverage: 'Acima da Média',
    average: 'Média',
    belowAverage: 'Abaixo da Média',
    needsDevelopment: 'Precisa de Desenvolvimento'
  }
};

export const factors = {
  // DCTOS Framework names
  drive: 'Impulso',
  connection: 'Conexão',
  task: 'Tarefa',
  order: 'Ordem',
  style: 'Estilo',
  // Legacy names (mapped to DCTOS)
  dominance: 'Impulso',
  extraversion: 'Conexão',
  patience: 'Tarefa',
  formality: 'Ordem',
  objectivity: 'Estilo',
  behavioralProfile: 'Perfil Comportamental',
  descriptions: {
    // DCTOS descriptions
    drive: 'Como você aborda problemas e desafios',
    connection: 'Como você interage e influencia outros',
    task: 'Como você responde ao ritmo e mudanças',
    order: 'Como você responde a regras e procedimentos',
    style: 'Como você processa informações e toma decisões',
    // Legacy descriptions
    dominance: 'Como você aborda problemas e desafios',
    extraversion: 'Como você interage e influencia outros',
    patience: 'Como você responde ao ritmo e mudanças',
    formality: 'Como você responde a regras e procedimentos',
    objectivity: 'Como você processa informações e toma decisões'
  },
  category: {
    veryLow: 'Muito Baixo',
    low: 'Baixo',
    moderate: 'Moderado',
    high: 'Alto',
    veryHigh: 'Muito Alto'
  }
};

export const insights = {
  dominance: {
    veryHigh: 'Líder natural que gera resultados através de ação decisiva',
    high: 'Toma iniciativa e se sente confortável tomando decisões importantes',
    moderate: 'Abordagem equilibrada para liderança e colaboração',
    low: 'Prefere tomada de decisão colaborativa e consenso da equipe',
    veryLow: 'Forte preferência por soluções baseadas em equipe'
  },
  extraversion: {
    veryHigh: 'Altamente social e energizado por interações com pessoas',
    high: 'Extrovertido e confortável em situações sociais',
    moderate: 'Preferências equilibradas de interação social',
    low: 'Valoriza interações significativas um-a-um',
    veryLow: 'Prefere ambientes de trabalho profundos e focados'
  },
  patience: {
    veryHigh: 'Extremamente estável e prefere ambientes consistentes',
    high: 'Paciente e deliberado na abordagem',
    moderate: 'Adaptável a diferentes ritmos de trabalho',
    low: 'Prefere ambientes dinâmicos e de ritmo acelerado',
    veryLow: 'Prospera com mudanças e tomada de decisão rápida'
  },
  formality: {
    veryHigh: 'Abordagem altamente sistemática e orientada para detalhes',
    high: 'Valoriza estrutura e segue procedimentos estabelecidos',
    moderate: 'Equilibra estrutura com flexibilidade',
    low: 'Pensamento adaptativo e inovador',
    veryLow: 'Abordagem altamente flexível e criativa'
  },
  objectivity: {
    veryHigh: 'Toma decisões baseadas puramente em fatos e análise lógica',
    high: 'Geralmente objetivo com bom pensamento analítico',
    moderate: 'Equilibra análise lógica com insights intuitivos',
    low: 'Considera emoções e relacionamentos junto com fatos',
    veryLow: 'Altamente intuitivo e valoriza inteligência emocional'
  }
};

export const tabs = {
  overview: 'Visão Geral',
  detailed: 'Análise Detalhada',
  development: 'Desenvolvimento',
  career: 'Caminhos de Carreira',
  words: 'Palavras'
};

export const professional = {
  style: {
    title: 'Estilo Profissional',
    subtitle: 'Sua abordagem natural para trabalho e colaboração'
  }
};

export const objectivity = {
  model: {
    calculated: 'Calculado',
    direct: 'Direto',
    reverse: 'Reverso'
  },
  description: {
    calculated: 'Baseado em Formalidade menos Extroversão',
    direct: 'Baseado em palavras de objetividade selecionadas',
    reverse: 'Comece em 100%, deduza para palavras subjetivas'
  }
};
